var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaitionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1523_8569)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0.416504C4.80272 0.416504 4.60926 0.46641 4.44094 0.560727C4.27263 0.655043 4.13596 0.790111 4.04601 0.951056L4.04443 0.953921L0.114665 8.15846C0.032637 8.30787 -0.006699 8.47458 0.000939331 8.64175C0.00858659 8.80911 0.0627747 8.97189 0.158358 9.11462C0.253941 9.25735 0.387746 9.37533 0.547065 9.45734C0.706384 9.53935 0.885931 9.58265 1.06865 9.58317H1.06973H8.93024H8.93131C9.11403 9.58265 9.29361 9.53935 9.4529 9.45734C9.61225 9.37533 9.74602 9.25735 9.84163 9.11462C9.93725 8.97189 9.99141 8.80911 9.99906 8.64175C10.0067 8.47458 9.96762 8.30833 9.88558 8.15892L5.95556 0.953921L5.95398 0.951056C5.86403 0.790111 5.72737 0.655043 5.55905 0.560727C5.39072 0.46641 5.19728 0.416504 5 0.416504Z",
    fill: "#E14590"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53711 3.48249C5.53711 3.18663 5.29726 2.94678 5.0014 2.94678C4.70553 2.94678 4.46568 3.18663 4.46568 3.48249V5.80392C4.46568 6.09978 4.70553 6.33963 5.0014 6.33963C5.29726 6.33963 5.53711 6.09978 5.53711 5.80392V3.48249ZM5.0014 8.48249C5.39588 8.48249 5.71568 8.16271 5.71568 7.76821C5.71568 7.37371 5.39588 7.05392 5.0014 7.05392C4.60691 7.05392 4.28711 7.37371 4.28711 7.76821C4.28711 8.16271 4.60691 8.48249 5.0014 8.48249Z",
    fill: "#FFE4F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1523_8569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaitionIcon);
export default __webpack_public_path__ + "static/media/caition-icon.d4652e0cbc951ba07d0d23e52336a483.svg";
export { ForwardRef as ReactComponent };